// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d0fd23b","732":"b5652fb5","977":"8f4d5bba"}[chunkId] + ".chunk.js";
};